/**
 * Helpers de manipulation de dates locale-safe.
 * On évite Date.toISOString() qui décale vers UTC.
 */

export function toIsoDate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function firstDayOfMonth(year, month) {
  // month: 0-indexed
  return new Date(year, month, 1);
}

export function lastDayOfMonth(year, month) {
  return new Date(year, month + 1, 0);
}

export function presetCurrentMonth() {
  const now = new Date();
  return {
    startDate: toIsoDate(firstDayOfMonth(now.getFullYear(), now.getMonth())),
    endDate: toIsoDate(lastDayOfMonth(now.getFullYear(), now.getMonth())),
  };
}

export function presetPreviousMonth() {
  const now = new Date();
  const target = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  return {
    startDate: toIsoDate(firstDayOfMonth(target.getFullYear(), target.getMonth())),
    endDate: toIsoDate(lastDayOfMonth(target.getFullYear(), target.getMonth())),
  };
}

export function presetCurrentQuarter() {
  const now = new Date();
  const quarter = Math.floor(now.getMonth() / 3);
  const startMonth = quarter * 3;
  return {
    startDate: toIsoDate(firstDayOfMonth(now.getFullYear(), startMonth)),
    endDate: toIsoDate(lastDayOfMonth(now.getFullYear(), startMonth + 2)),
  };
}

const MONTHS_FR = [
  'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre',
];

export function formatMonthFr(isoDate) {
  if (!isoDate) return '';
  const [y, m] = isoDate.split('-');
  return `${MONTHS_FR[Number(m) - 1]} ${y}`;
}

export function formatDateFr(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
